import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * 路由切换时自动滚动到页面顶部，保证点击分类/文章后从顶部开始阅读。
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}